import { reactive, toRefs } from 'vue';
import { srcType } from "@/utils/srcType";
export default {
  props: {
    detail: {
      type: Object,
      default: () => {}
    }
  },
  setup() {
    const data = reactive({
      srcType: srcType
    });
    return {
      ...toRefs(data)
    };
  }
};